/**
 * id 가 없는 정적 목록(도입부 대사·대본 줄)에 내용 기반 key 를 붙인다.
 * 같은 문장이 두 번 나오면 등장 순번(#2)을 덧붙여 겹치지 않게 한다 — 위치(index)에 기대지 않는다.
 */
export function contentKeys<T>(
  items: T[],
  text: (item: T) => string
): { key: string; item: T }[] {
  const seen = new Map<string, number>()
  return items.map((item) => {
    const base = text(item)
    const n = (seen.get(base) || 0) + 1
    seen.set(base, n)
    return { key: n > 1 ? `${base}#${n}` : base, item }
  })
}
